import $ from "jquery";

export default class FadeEffects {

	//* Run 0.25 seconds after document ready for any instances viewable on load

	static init() {

		setTimeout( function() {
			FadeEffects.animateObject();
		}, 100);

		$(window).scroll( function() {

			//* Run on scroll
			FadeEffects.animateObject();

		});
	}

	static animateObject() {

		//* Define your object via class
		var fadeIn = $( '.fadein-effect' ),
				fadeDown = $( '.fadedown-effect' ),
				fadeUp = $( '.fadeup-effect');

		if ( fadeIn.length > 0 ) {
			FadeEffects.animateSetClass( fadeIn, 'fadeIn' );
		}

		if ( fadeDown.length > 0 ) {
			FadeEffects.animateSetClass( fadeDown, 'fadeInDown' );
		}

		if ( fadeUp.length > 0 ) {
			FadeEffects.animateSetClass( fadeUp, 'fadeInUp' );
		}

	}

	static animateSetClass( object, className ) {

		//* Loop through each object in the array
		$.each( object, function() {

			var windowHeight = $(window).height(),
				offset 		 = $(this).offset().top,
				top			 = offset - $(document).scrollTop(),
				percent 	 = Math.floor( top / windowHeight * 100 );

			if ( percent < 90 ) {

				$(this).addClass( className );
			}

		});

	}
}